import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';

export default function TwitterMetadataIcon() {
  return (
    <div className="itemMetadata-twitterIcon itemMetadata-fontawesome">
      <FontAwesomeIcon icon={faTwitter} />
    </div>
  );
}
